interface ProductCategory {
  id: number;
  name: string;
}

interface ProductBasicInfoProps {
  id: number;
  name: string;
  category: ProductCategory;
  subCategory: ProductCategory;
  status: boolean;
  createdAt?: string;
  updatedAt?: string;
  onEdit?: () => void;
}

export default function ProductBasicInfo({
  name,
  category,
  subCategory,
  status,
  createdAt,
  updatedAt,
  onEdit,
}: ProductBasicInfoProps) {

  
  return (
    <div className="rounded-3xl bg-white p-8 shadow-sm">
      {/* Header */}
      <div className="mb-8 flex items-center justify-between border-b border-gray-100 pb-5">
        <h2 className="text-2xl font-bold text-gray-900">Basic Information</h2>

        <button
          onClick={onEdit}
          className="rounded-lg bg-blue-600 px-5 py-2 font-medium text-white transition hover:bg-blue-700">
          Edit Product
        </button>
      </div>


      {/* Content */}
      <div className="grid grid-cols-2 gap-x-16 gap-y-6">
        <InfoItem label="Product Name" value={name} />

        <InfoItem label="Sub Category" value={subCategory.name} />

        <InfoItem label="Category" value={category.name} />

        <div className="flex items-center gap-5">
          <span className="w-32 font-medium text-gray-500">Status</span>

          <span
            className={`rounded-full px-4 py-1 text-sm font-semibold ${
              status ? "bg-green-100 text-green-700" : "bg-red-100 text-red-700"
            }`}>
            {status ? "Active" : "Inactive"}
          </span>
        </div>

        <InfoItem label="Created At" value={createdAt ?? "-"} />

        <InfoItem label="Updated At" value={updatedAt ?? "-"} />
      </div>
    </div>
  );
}

interface InfoItemProps {
  label: string;
  value: string;
}

function InfoItem({ label, value }: InfoItemProps) {
  return (
    <div className="flex items-center gap-5">
      <span className="w-32 font-medium text-gray-500">{label}</span>

      <span className="font-semibold text-gray-900">{value}</span>
    </div>
  );
}
